export default __webpack_public_path__ + "static/media/v3Our-services-Group-photo.4fad760d.jpg";